import { useMemo } from "react";
import styled from "styled-components";
import { FooterState } from "../store/chart";
import { Text } from "../components/Text";
import { FontWeight, UIImage } from "../types";
import { Container } from "./Container";

type FooterProps = {
  className?: string;
  footerSection: FooterState;
};

export function FooterSection({ className, footerSection }: FooterProps) {
  const logoChunks = useMemo(
    () => spliceIntoChunks(footerSection.logos, 6),
    [footerSection.logos],
  );
  return (
    <StyledFooter className={className}>
      <StyledContainer>
        {footerSection && (
          <StyledFooterTitle
            font={footerSection.title.font}
            textColor={footerSection.title.color}
          >
            {footerSection.title.value}
          </StyledFooterTitle>
        )}
        {logoChunks.map((logos, chunkIndex) => (
          <StyledLogosContainer key={`logo-container-${chunkIndex}`}>
            {logos.map((section, index) => (
              <img src={section.url} key={`img-${index}`} alt={section.alt} />
            ))}
          </StyledLogosContainer>
        ))}
      </StyledContainer>
    </StyledFooter>
  );
}

function spliceIntoChunks(logos: UIImage[], chunkSize: number): UIImage[][] {
  const arr = [...logos];
  const res: UIImage[][] = [];
  while (arr.length > 0) {
    const chunk = arr.splice(0, chunkSize);
    res.push(chunk);
  }
  return res;
}

const StyledFooter = styled.div`
  padding: ${({ theme }) =>
    theme.isMobile
      ? `${theme.getValue(32)}px ${theme.getValue(16)}px ${theme.getValue(
          112,
        )}px`
      : `${theme.getValue(56)}px ${theme.getValue(16)}px`};
  background-color: ${({ theme }) => theme.colors.white};
`;

const StyledContainer = styled(Container)`
  max-width: ${({ theme }) => theme.getValue(700)}px;
  padding: 0;
`;

const StyledFooterTitle = styled(Text)`
  &&& {
    font-weight: ${({ font: { weight = FontWeight.Black } = {} }) => weight};
    font-style: italic;
    font-size: ${({ theme }) =>
      theme.isMobile
        ? `${theme.getFontSize(24)}px`
        : `${theme.getFontSize(36)}px`};
    line-height: 1;
    text-align: center;
    color: ${({ theme }) => theme.colors.green1};
    margin: 0;
  }
`;

const StyledLogosContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) =>
    theme.isMobile ? theme.getValue(36) : theme.getValue(56)}px;
  column-gap: ${({ theme }) =>
    theme.isMobile ? `${theme.getValue(12)}px` : `${theme.getValue(40)}px`};

  img {
    display: block;
    width: auto;
    height: auto;
    max-height: ${({ theme }) =>
      theme.isMobile ? theme.getValue(30) : theme.getValue(64)}px;
    max-width: ${({ theme }) =>
      theme.isMobile ? theme.getValue(70) : theme.getValue(146)}px;
  }
`;
